import { render, staticRenderFns } from "./SectionSider.vue?vue&type=template&id=e05372ac&"
import script from "./SectionSider.vue?vue&type=script&lang=js&"
export * from "./SectionSider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports